import { onSmimeItemAttachmentOpened } from '../actions/externalActions';
import { getStore as getMailStore } from 'owa-mail-store/lib/store/Store';
import { mutator } from 'satcheljs';

/**
 * Responsible for populating the mail store with the item attachment's data
 */
export default mutator(onSmimeItemAttachmentOpened, actionMessage => {
    const { itemId, item, mailboxInfo } = actionMessage;
    item.MailboxInfo = mailboxInfo;
    getMailStore().items.set(itemId, item);
});
